<template>
  <div class="title">
    <!-- 醴陵金融纠纷调解中心 -->
    <navbar></navbar>
  </div>
</template>

<script>
import navbar from '../components/navbar.vue'
export default {
  components: {
    navbar
  },
  data() {
    return {

    }
  }
}
</script>

<style scoped>
.title {
  width: 100%;
  height: 3rem;
  background: url('../assets/img/base/title-bg.svg') no-repeat center center;
  display: flex;
  justify-content: center;
  align-items: center;
  /* color: black; */
  /* 阴影 */
  box-shadow: 0 0 0.8rem 0 rgba(0, 0, 0, .3);
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99999999999999999;
  position: fixed;
}
</style>



// WEBPACK FOOTER //
// src/components/title.vue